<div class="container">
  <p class="p"><strong>Already have a doctor?</strong></p>
  <p class="p2">View the <a [href]="link" [target]="target">providers you’ve seen before</a>.</p>
</div>
